import React, { useContext, useEffect, useState } from "react";
import { Container, Card, CardBody, Row, Col, Badge } from "reactstrap";
import { BarChart2, TrendingUp, TrendingDown, AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import MainContext from "../../Components/Contexts/MainContext";
// #506: the Elektrik taahhütname's signature levels at the selected fair.
import ElektrikTaahhutnameKarti from "../../Components/Projects/ElektrikTaahhutnameKarti";
import { getAllFilledForms, TYPE_NAMES } from "../../services/sahaInspectionService";

function SahaIstatistikler() {
  const { t } = useTranslation("saha");
  const { selectedFuarId } = useContext(MainContext);
  // getAllFilledForms async fonksiyon — useState + useEffect ile çağrılmalı
  const [forms, setForms] = useState([]);

  useEffect(() => {
    getAllFilledForms().then(setForms);
  }, []);

  useEffect(() => {
    document.title = t("sahaIstatistikler.sayfaBasligi");
  }, [t]);

  const total      = forms.length;
  const done       = forms.filter((f) => f.isDone).length;
  const uygunsuz   = forms.filter((f) => f.inspectionLevelId === 2).length;
  const dof        = forms.filter((f) => f.inspectionLevelId === 3).length;

  // Tipe göre dağılım
  const byType = forms.reduce((acc, f) => {
    const name = TYPE_NAMES[f.inspectionTypeId] || t("sahaIstatistikler.tipNo", { id: f.inspectionTypeId });
    acc[name] = (acc[name] || 0) + 1;
    return acc;
  }, {});

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title={t("sahaIstatistikler.baslik")} pageTitle={t("sahaIstatistikler.fdsSaha")} />

        <Row className="g-3 mb-4">
          {[
            { label: t("sahaIstatistikler.toplamKayit"), value: total,    color: "primary",   icon: <BarChart2     size={20}/> },
            { label: t("sahaIstatistikler.tamamlanan"),  value: done,     color: "success",   icon: <TrendingUp    size={20}/> },
            { label: t("sahaIstatistikler.uygunsuzluk"), value: uygunsuz, color: "warning",   icon: <AlertTriangle size={20}/> },
            { label: t("sahaIstatistikler.kapaliDof"),   value: dof,      color: "info",      icon: <TrendingDown  size={20}/> },
          ].map((s) => (
            <Col key={s.label} xs={6} md={3}>
              <Card className="border-0 shadow-sm">
                <CardBody className="d-flex align-items-center gap-3">
                  <div className={`text-${s.color}`}>{s.icon}</div>
                  <div>
                    <div className="fw-bold fs-4">{s.value}</div>
                    <div className="text-muted small">{s.label}</div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>

        <ElektrikTaahhutnameKarti fuarId={selectedFuarId} />

        <Card className="border-0 shadow-sm">
          <CardBody>
            <h6 className="fw-semibold mb-3">{t("sahaIstatistikler.denetimTipineGoreDagilim")}</h6>
            {Object.entries(byType).map(([name, count]) => (
              <div key={name} className="d-flex align-items-center gap-3 mb-2">
                <span className="small text-muted" style={{ minWidth: 180 }}>{name}</span>
                <div className="flex-grow-1 bg-light rounded" style={{ height: 10 }}>
                  <div
                    className="bg-primary rounded"
                    style={{ height: "100%", width: `${Math.round((count / total) * 100)}%`, transition: "width .3s" }}
                  />
                </div>
                <Badge color="primary" pill>{count}</Badge>
              </div>
            ))}
            <p className="text-muted small mt-3 mb-0">
              {t("sahaIstatistikler.grafiklerNotu")}
            </p>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
}

export default SahaIstatistikler;

